import { combineReducers } from 'redux';
import authReducer from './auth/reducers/authReducer';
import { forgotPasswordReducer } from './auth/reducers/forgotPasswordReducer';
import { resetPasswordReducer } from './auth/reducers/resetPasswordReducer';
import signupReducer from './auth/reducers/signupReducer';
import { availabilityReducer } from './availability/reducer/availabilityReducer';
import chatListReducer from './chat/reducers/chatListReducer';
import { invitedLocationsReducer } from './invited-locations/reducer/invitedLocationReducer';
import locationReducer from './location/reducer/locationReducer';
import getNotificationListReducer from './notification/reducers/getNotificationListReducer';
import notifyVisitorReducer from './notification/reducers/notifyVisitorReducer';
import staffReducer from './staff/reducers/staffReducer';
import { store } from './store';
import { addStaffToastReducer } from './toast/reducers/addStaffToast.reducer';
import twilioReducer from './twilio/reducers/twilio.reducer';
import unitByIdReducer from './units/reducers/unitByIdReducer';
import { unitByLocationIdReducer } from './units/reducers/unitByLocationIdReducer';
import unitsReducer from './units/reducers/unitsReducer';
import appointmentReducer from './visits/reducers/visitsReducer';
import lockerListReducer from './locker-list/reducer/locker-list.reducer';
import { tourExperienceReducer } from './tour/reducer/tourExperienceReducer';
import { visitorListReducer } from './visitor-list/reducer/visitor-list.reducer';
import createAppoinmentReducer from './visitor-list/reducer/createAppoinment.reducer';
import { appointmentVisitorListReducer } from './appointment-visitors/reducer/appointment-visitors.reducer';
import { chargeUserReducer } from './charge-user/reducer/chargeUser.reducer';
import { lockerWiseAvailabilityAndAppointmentsReducer } from './locker-wise-availability/reducer/lockerWiseAvailabilityAndAppointmentsReducer';
import { syncGuestCardReducer } from './sync-guestCard/reducer/syncGuestCardReducer';
import { metricsReducer } from './metrics/reducer/metricsReducer';
import { leadSourceReducer } from './lead-sources/reducer/leadSourcesReducer';
import landmarkReducer from './landmark/reducer/landmarkReducer';
import { invitedStaffReducer } from './invited-staff/reducer/invitedStaff.reducer';
import { editProfileReducer } from './auth/reducers/editProfileReducer';
import { managemnetReducer } from './user-management/reducers/userManagementReducers';
import { rolesListReducer } from './roles/reducer/roles.reducer';
import { permissionsListReducer } from './permissions/reducer/permissions.reducer';
import storage from "redux-persist/lib/storage";
import persistReducer from 'redux-persist/es/persistReducer';
import { permissionsReducer } from './setInitialPermission/reducer/setInitialPermission.reducer';
import staffManagementReducer from './staff-management/reducer/staff.reducers';
import lockerTypeReducer from './locker-version/reducer/locker-version.reducer';
import { vendorAppintmentListReducer } from './vendor/reducer/vendor.reducer';
import { vendorLockerListReducer } from './vendor-locker-list/reducer/vendorLockerList.reducer';
import { vendorListReducer } from './vendor/reducer/vendors.reducer';
import { vendorsByLocationReducer } from './vendor/reducer/vendorsByLocation.reducer';
import { locationsComprehensiveReducer } from './locationsComprehensive/reducer/locationsComprehensive.reducer';
import { propertyEventReducer } from './key-pickup-drop-events/reducer/key-pickup-drop-events.reducer';
import { eventsLockerListReducer } from './events-locker-list/reducer/eventsLockerList.reducer';
import appointmentUnitsReducer from './appointment-units/reducer/appointmentUnits.reducer';
import locationUnitsListReducer from './location-units-list/reducer/locationUnitsList.reducer';
import { supportTicketReducer } from './support-ticket/reducer/support-ticket.reducer';
import { pmsConnectReducer } from './pms-connect/reducers/pms-connect.reducer';
import { conciergeReducer } from './Concierge/reducer/concierge.reducer';
import { managementCompanyReducer } from './management-company/reducer/management-company.reducer';
import { kioskStatusReducer } from './kiosk-status/reducer/kiosk-status.reducer';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['authReducer', 'permissionsReducer']
};

const rootReducer = combineReducers({
    units: unitsReducer,
    unitById: unitByIdReducer,
    chatList: chatListReducer,
    notificationList: getNotificationListReducer,
    authReducer: authReducer,
    signupReducer: signupReducer,
    notifyVisitor: notifyVisitorReducer,
    staff: staffReducer,
    addStaffToast: addStaffToastReducer,
    twilio: twilioReducer,
    appointmentReducer: appointmentReducer,
    locationReducer: locationReducer,
    availability: availabilityReducer,
    unitsByLocationId: unitByLocationIdReducer,
    invitedLocations: invitedLocationsReducer,
    forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    lockerList: lockerListReducer,
    tourExperience: tourExperienceReducer,
    VisitorListReducer: visitorListReducer,
    createAppoinmentReducer: createAppoinmentReducer,
    appointmentVisitor: appointmentVisitorListReducer,
    chargeUser: chargeUserReducer,
    lockerWiseAvailabilityAndAppointments: lockerWiseAvailabilityAndAppointmentsReducer,
    syncGuestCardReducer: syncGuestCardReducer,
    metricsReducer: metricsReducer,
    leadSourceReducer: leadSourceReducer,
    landmarkReducer: landmarkReducer,
    invitedStaffReducer: invitedStaffReducer,
    editProfileReducer: editProfileReducer,
    managementReducer: managemnetReducer,
    rolesListReducer: rolesListReducer,
    permissionsListReducer: permissionsListReducer,
    permissionsReducer: permissionsReducer,
    staffManagementReducer: staffManagementReducer,
    lockerTypeReducer: lockerTypeReducer,
    vendorAppintmentListReducer: vendorAppintmentListReducer,
    vendorListReducer: vendorListReducer,
    vendorLockerListReducer: vendorLockerListReducer,
    vendorsByLocationReducer: vendorsByLocationReducer,
    locationsComprehensiveReducer: locationsComprehensiveReducer,
    propertyEventReducer: propertyEventReducer,
    keyDropEventReducer: eventsLockerListReducer,
    appointmentUnits: appointmentUnitsReducer,
    locationUnitsList: locationUnitsListReducer,
    supportTicketReducer: supportTicketReducer,
    pmsConnectReducer: pmsConnectReducer,
    conciergeReducer: conciergeReducer,
    managementCompanyReducer: managementCompanyReducer,
    kioskStatusReducer: kioskStatusReducer,
});

export type IRootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export default persistReducer(persistConfig, rootReducer);
